import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Modal, Button, Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { createForm, updateForm } from '../services/project/formGroupService';

const schema = Yup.object({
  name: Yup.string().trim().required('Form name is required').max(100),
});

const EditFormModal = ({ form, show, onClose, refetch = () => {} }) => {
  const { projectId } = useParams();
  const formik = useFormik({
    initialValues: { name: form?.name || '' },
    enableReinitialize: true,
    validationSchema: schema,
    onSubmit: async ({ name }, { setSubmitting }) => {
      try {
        const payload = name.trim();
        if (form?.id) {
          const { message } = await updateForm(projectId, form.id, payload);
          toast.success(message || 'Form renamed');
        } else {
          const { message } = await createForm(payload);
          toast.success(message || 'Form created');
        }
        refetch();
        onClose();
      } catch (error) {
        console.log(error)
        const msg =
          error?.errorMessage ||
          error?.response?.data?.errorMessage ||
          'Something went wrong';
        toast.error(msg);
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        document.getElementById('formNameInput')?.focus();
      }, 100);
    }
  }, [show]);

  const unchanged =
    (form?.name || '').trim() === (formik.values.name || '').trim();

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{form ? 'Edit Form' : 'New Form'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group className="mb-3" controlId="formNameInput">
            <Form.Label>Form Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter form name"
              {...formik.getFieldProps('name')}
              isInvalid={formik.touched.name && !!formik.errors.name}
              disabled={formik.isSubmitting}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.name}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={onClose} disabled={formik.isSubmitting}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              disabled={formik.isSubmitting || unchanged || !!formik.errors.name}
            >
              {formik.isSubmitting ? 'Saving…' : 'Save'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditFormModal;